const { BASE_URL } = require("../client");


const UPDATE_FEATURES_KITPAGE = BASE_URL + "/Kitpage/Features/";
const GET_FEATURES_KITPAGE= BASE_URL + "/Kitpage/Features/";

export {
    UPDATE_FEATURES_KITPAGE,
    GET_FEATURES_KITPAGE
}